import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0acf081f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quizz-question" }
const _hoisted_2 = { class: "quizz-question-answers" }
const _hoisted_3 = ["innerHTML"]

import QuizzButton from '../QuizzButton.vue'
import { QuizzSentence } from '@/types/Quizz'


export default /*#__PURE__*/_defineComponent({
  props: {
    currentAnswersId: null,
    sentence: null,
    showJustification: { type: Boolean }
  },
  emits: ['update:currentAnswersId'],
  setup(__props: any, { emit }) {

const props = __props as {
  currentAnswersId: number[] // v-model

  sentence: QuizzSentence
  showJustification: boolean
}





function isCorrect(id: number) {
  return props.showJustification && props.sentence.correctAnswers.includes(id)
}

function isWrong(id: number) {
  return (
    props.showJustification &&
    props.currentAnswersId.includes(id) &&
    !props.sentence.correctAnswers.includes(id)
  )
}

function onAnswerClick(id: number) {
  const answersId = props.currentAnswersId

  const index = answersId.findIndex((answerId) => answerId === id)

  if (index == -1) {
    answersId.push(id)
  } else {
    answersId.splice(index, 1)
  }

  emit('update:currentAnswersId', answersId)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", {
        class: "text-lg",
        innerHTML: _ctx.$t(props.sentence.description)
      }, null, 8, _hoisted_3),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.sentence.answers, (answer) => {
        return (_openBlock(), _createBlock(QuizzButton, {
          class: _normalizeClass(["btn-answer", {
          'quizz-question-answers-justification': props.showJustification,
        }]),
          text: _ctx.$t(answer.answer),
          key: answer.id,
          selected: props.currentAnswersId.includes(answer.id),
          correct: isCorrect(answer.id),
          wrong: isWrong(answer.id),
          onClick: ($event: any) => (!props.showJustification && onAnswerClick(answer.id))
        }, null, 8, ["class", "text", "selected", "correct", "wrong", "onClick"]))
      }), 128))
    ])
  ]))
}
}

})